import { createReducer, on } from '@ngrx/store';
import { setCustomer } from './customer.reduce';

export const initialState = {
  names: '',
};

export const customerReducer = createReducer(
  initialState,
  on(setCustomer, (state, { customer }) => ({ ...state, ...customer }))
);
